import type { MetaInfo } from 'vue-meta';

import { getSimpleProductGallery } from '~/modules/catalog/product/getters/productGetters';
import { ProductInterface } from '~/modules/GraphQL/types';

export const getMetaInfo = (page: any, isNoIndex: boolean = false, canonicalUrl: string = '', removeParamsFromCanonical: boolean = false, preloadImage: boolean = false): MetaInfo => {
  if (!page) {
    return null;
  }

  const seoTags: MetaInfo = {
    meta: [],
  };

  if (page?.meta_title || page?.title || page?.name) {
    seoTags.title = page?.meta_title || page?.title || page?.name;
  }
  if (page?.meta_description) {
    seoTags.meta.push({
      hid: 'description',
      name: 'description',
      content: page.meta_description,
    });
  }
  if (page?.meta_keyword || page?.meta_keywords) {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: page?.meta_keyword || page?.meta_keywords,
    });
  }
  if (isNoIndex) {
    seoTags.meta.push({
      name: 'robots',
      content: 'noindex, nofollow',
    });
  }

  if (canonicalUrl) {
    seoTags.link = [
      { hid: 'canonical', rel: 'canonical', href: removeParamsFromCanonical ? canonicalUrl.split('?')[0] : canonicalUrl },
    ];
  }

  if (preloadImage) {
    const img = getSimpleProductGallery(page as ProductInterface)?.[0];

    if (img) {
      seoTags.link.push({
        rel: 'preload',
        href: img.big,
        as: 'image',
      });
    }
  }

  return seoTags;
};
